import {useEffect, useState} from "react";
import {useGraphqlLazyQuery} from "../../../amplify";
import {
  Tenant,
  TenantByIdQuery,
  TenantByIdQueryVariables
} from "../../../amplify/graphql";
import {tenantById as tenantByIdQuery} from "../../../amplify/graphql";

interface UseTenancyResult {
  tenant: Tenant | null;
  loading: boolean;
  error: Error | null;
}

export function useTenancy(tenantId: string | undefined): UseTenancyResult {
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const [trigger, {loading}] = useGraphqlLazyQuery<
    TenantByIdQuery,
    TenantByIdQueryVariables
  >({
    amplifyQuery: tenantByIdQuery
  });

  useEffect(() => {
    if (!tenantId) return;

    trigger({variables: {id: tenantId}})
      .then(result => {
        setTenant(result.data?.tenantById ?? null);
      })
      .catch(err => {
        setError(err instanceof Error ? err : new Error(String(err)));
      });
  }, [tenantId, trigger]);

  if (!tenantId) {
    return {tenant: null, loading: false, error: null};
  }

  return {tenant, loading, error};
}
